module.exports = __webpack_public_path__ + "img/impraise.303c5ada.png";